// Конфигурация флагов стран
export const flagsConfig = {
  unknown: { name: "Unknown", region: "Без региона" },
  ad: { name: "Андорра", region: "Европа" },
  ae: { name: "ОАЭ", region: "Азия" },
  af: { name: "Афганистан", region: "Азия" },
  ag: { name: "Антигуа и Барбуда", region: "Америка" },
  ai: { name: "Ангилья", region: "Америка" },
  al: { name: "Албания", region: "Европа" },
  am: { name: "Армения", region: "Азия" },
  ao: { name: "Ангола", region: "Африка" },
  aq: { name: "Антарктида", region: "Антарктика" },
  ar: { name: "Аргентина", region: "Америка" },
  as: { name: "Американское Самоа", region: "Океания" },
  at: { name: "Австрия", region: "Европа" },
  au: { name: "Австралия", region: "Океания" },
  aw: { name: "Аруба", region: "Америка" },
  ax: { name: "Аландские острова", region: "Европа" },
  az: { name: "Азербайджан", region: "Азия" },
  ba: { name: "Босния и Герцеговина", region: "Европа" },
  bb: { name: "Барбадос", region: "Америка" },
  bd: { name: "Бангладеш", region: "Азия" },
  be: { name: "Бельгия", region: "Европа" },
  bf: { name: "Буркина-Фасо", region: "Африка" },
  bg: { name: "Болгария", region: "Европа" },
  bh: { name: "Бахрейн", region: "Азия" },
  bi: { name: "Бурунди", region: "Африка" },
  bj: { name: "Бенин", region: "Африка" },
  bl: { name: "Сен-Бартелеми", region: "Америка" },
  bm: { name: "Бермуды", region: "Америка" },
  bn: { name: "Бруней", region: "Азия" },
  bo: { name: "Боливия", region: "Америка" },
  bq: { name: "Бонэйр", region: "Америка" },
  br: { name: "Бразилия", region: "Америка" },
  bs: { name: "Багамы", region: "Америка" },
  bt: { name: "Бутан", region: "Азия" },
  bv: { name: "Остров Буве", region: "Антарктика" },
  bw: { name: "Ботсвана", region: "Африка" },
  by: { name: "Беларусь", region: "Европа" },
  bz: { name: "Белиз", region: "Америка" },
  ca: { name: "Канада", region: "Америка" },
  cc: { name: "Кокосовые острова", region: "Азия" },
  cd: { name: "ДР Конго", region: "Африка" },
  cf: { name: "ЦАР", region: "Африка" },
  cg: { name: "Республика Конго", region: "Африка" },
  ch: { name: "Швейцария", region: "Европа" },
  ci: { name: "Кот-д'Ивуар", region: "Африка" },
  ck: { name: "Острова Кука", region: "Океания" },
  cl: { name: "Чили", region: "Америка" },
  cm: { name: "Камерун", region: "Африка" },
  cn: { name: "Китай", region: "Азия" },
  co: { name: "Колумбия", region: "Америка" },
  cr: { name: "Коста-Рика", region: "Америка" },
  cu: { name: "Куба", region: "Америка" },
  cv: { name: "Кабо-Верде", region: "Африка" },
  cw: { name: "Кюрасао", region: "Америка" },
  cx: { name: "Остров Рождества", region: "Азия" },
  cy: { name: "Кипр", region: "Европа" },
  cz: { name: "Чехия", region: "Европа" },
  de: { name: "Германия", region: "Европа" },
  dj: { name: "Джибути", region: "Африка" },
  dk: { name: "Дания", region: "Европа" },
  dm: { name: "Доминика", region: "Америка" },
  do: { name: "Доминиканская Республика", region: "Америка" },
  dz: { name: "Алжир", region: "Африка" },
  ec: { name: "Эквадор", region: "Америка" },
  ee: { name: "Эстония", region: "Европа" },
  eg: { name: "Египет", region: "Африка" },
  eh: { name: "Западная Сахара", region: "Африка" },
  er: { name: "Эритрея", region: "Африка" },
  es: { name: "Испания", region: "Европа" },
  et: { name: "Эфиопия", region: "Африка" },
  fi: { name: "Финляндия", region: "Европа" },
  fj: { name: "Фиджи", region: "Океания" },
  fk: { name: "Фолклендские острова", region: "Америка" },
  fm: { name: "Микронезия", region: "Океания" },
  fo: { name: "Фарерские острова", region: "Европа" },
  fr: { name: "Франция", region: "Европа" },
  ga: { name: "Габон", region: "Африка" },
  gb: { name: "Великобритания", region: "Европа" },
  gd: { name: "Гренада", region: "Америка" },
  ge: { name: "Грузия", region: "Азия" },
  gf: { name: "Французская Гвиана", region: "Америка" },
  gg: { name: "Гернси", region: "Европа" },
  gh: { name: "Гана", region: "Африка" },
  gi: { name: "Гибралтар", region: "Европа" },
  gl: { name: "Гренландия", region: "Америка" },
  gm: { name: "Гамбия", region: "Африка" },
  gn: { name: "Гвинея", region: "Африка" },
  gp: { name: "Гваделупа", region: "Америка" },
  gq: { name: "Экваториальная Гвинея", region: "Африка" },
  gr: { name: "Греция", region: "Европа" },
  gs: { name: "Южная Георгия", region: "Антарктика" },
  gt: { name: "Гватемала", region: "Америка" },
  gu: { name: "Гуам", region: "Океания" },
  gw: { name: "Гвинея-Бисау", region: "Африка" },
  gy: { name: "Гайана", region: "Америка" },
  hk: { name: "Гонконг", region: "Азия" },
  hm: { name: "Остров Херд", region: "Антарктика" },
  hn: { name: "Гондурас", region: "Америка" },
  hr: { name: "Хорватия", region: "Европа" },
  ht: { name: "Гаити", region: "Америка" },
  hu: { name: "Венгрия", region: "Европа" },
  id: { name: "Индонезия", region: "Азия" },
  ie: { name: "Ирландия", region: "Европа" },
  il: { name: "Израиль", region: "Азия" },
  im: { name: "Остров Мэн", region: "Европа" },
  in: { name: "Индия", region: "Азия" },
  io: { name: "Британская территория в Индийском океане", region: "Азия" },
  iq: { name: "Ирак", region: "Азия" },
  ir: { name: "Иран", region: "Азия" },
  is: { name: "Исландия", region: "Европа" },
  it: { name: "Италия", region: "Европа" },
  je: { name: "Джерси", region: "Европа" },
  jm: { name: "Ямайка", region: "Америка" },
  jo: { name: "Иордания", region: "Азия" },
  jp: { name: "Япония", region: "Азия" },
  ke: { name: "Кения", region: "Африка" },
  kg: { name: "Кыргызстан", region: "Азия" },
  kh: { name: "Камбоджа", region: "Азия" },
  ki: { name: "Кирибати", region: "Океания" },
  km: { name: "Коморы", region: "Африка" },
  kn: { name: "Сент-Китс и Невис", region: "Америка" },
  kp: { name: "КНДР", region: "Азия" },
  kr: { name: "Южная Корея", region: "Азия" },
  kw: { name: "Кувейт", region: "Азия" },
  ky: { name: "Каймановы острова", region: "Америка" },
  kz: { name: "Казахстан", region: "Азия" },
  la: { name: "Лаос", region: "Азия" },
  lb: { name: "Ливан", region: "Азия" },
  lc: { name: "Сент-Люсия", region: "Америка" },
  li: { name: "Лихтенштейн", region: "Европа" },
  lk: { name: "Шри-Ланка", region: "Азия" },
  lr: { name: "Либерия", region: "Африка" },
  ls: { name: "Лесото", region: "Африка" },
  lt: { name: "Литва", region: "Европа" },
  lu: { name: "Люксембург", region: "Европа" },
  lv: { name: "Латвия", region: "Европа" },
  ly: { name: "Ливия", region: "Африка" },
  ma: { name: "Марокко", region: "Африка" },
  mc: { name: "Монако", region: "Европа" },
  md: { name: "Молдова", region: "Европа" },
  me: { name: "Черногория", region: "Европа" },
  mf: { name: "Сен-Мартен", region: "Америка" },
  mg: { name: "Мадагаскар", region: "Африка" },
  mh: { name: "Маршалловы острова", region: "Океания" },
  mk: { name: "Северная Македония", region: "Европа" },
  ml: { name: "Мали", region: "Африка" },
  mm: { name: "Мьянма", region: "Азия" },
  mn: { name: "Монголия", region: "Азия" },
  mo: { name: "Макао", region: "Азия" },
  mp: { name: "Северные Марианские острова", region: "Океания" },
  mq: { name: "Мартиника", region: "Америка" },
  mr: { name: "Мавритания", region: "Африка" },
  ms: { name: "Монтсеррат", region: "Америка" },
  mt: { name: "Мальта", region: "Европа" },
  mu: { name: "Маврикий", region: "Африка" },
  mv: { name: "Мальдивы", region: "Азия" },
  mw: { name: "Малави", region: "Африка" },
  mx: { name: "Мексика", region: "Америка" },
  my: { name: "Малайзия", region: "Азия" },
  mz: { name: "Мозамбик", region: "Африка" },
  na: { name: "Намибия", region: "Африка" },
  nc: { name: "Новая Каледония", region: "Океания" },
  ne: { name: "Нигер", region: "Африка" },
  nf: { name: "Остров Норфолк", region: "Океания" },
  ng: { name: "Нигерия", region: "Африка" },
  ni: { name: "Никарагуа", region: "Америка" },
  nl: { name: "Нидерланды", region: "Европа" },
  no: { name: "Норвегия", region: "Европа" },
  np: { name: "Непал", region: "Азия" },
  nr: { name: "Науру", region: "Океания" },
  nu: { name: "Ниуэ", region: "Океания" },
  nz: { name: "Новая Зеландия", region: "Океания" },
  om: { name: "Оман", region: "Азия" },
  pa: { name: "Панама", region: "Америка" },
  pe: { name: "Перу", region: "Америка" },
  pf: { name: "Французская Полинезия", region: "Океания" },
  pg: { name: "Папуа — Новая Гвинея", region: "Океания" },
  ph: { name: "Филиппины", region: "Азия" },
  pk: { name: "Пакистан", region: "Азия" },
  pl: { name: "Польша", region: "Европа" },
  pm: { name: "Сен-Пьер и Микелон", region: "Америка" },
  pn: { name: "Питкэрн", region: "Океания" },
  pr: { name: "Пуэрто-Рико", region: "Америка" },
  ps: { name: "Палестина", region: "Азия" },
  pt: { name: "Португалия", region: "Европа" },
  pw: { name: "Палау", region: "Океания" },
  py: { name: "Парагвай", region: "Америка" },
  qa: { name: "Катар", region: "Азия" },
  re: { name: "Реюньон", region: "Африка" },
  ro: { name: "Румыния", region: "Европа" },
  rs: { name: "Сербия", region: "Европа" },
  ru: { name: "Россия", region: "Европа" },
  rw: { name: "Руанда", region: "Африка" },
  sa: { name: "Саудовская Аравия", region: "Азия" },
  sb: { name: "Соломоновы острова", region: "Океания" },
  sc: { name: "Сейшелы", region: "Африка" },
  sd: { name: "Судан", region: "Африка" },
  se: { name: "Швеция", region: "Европа" },
  sg: { name: "Сингапур", region: "Азия" },
  sh: { name: "Святая Елена", region: "Африка" },
  si: { name: "Словения", region: "Европа" },
  sj: { name: "Шпицберген", region: "Европа" },
  sk: { name: "Словакия", region: "Европа" },
  sl: { name: "Сьерра-Леоне", region: "Африка" },
  sm: { name: "Сан-Марино", region: "Европа" },
  sn: { name: "Сенегал", region: "Африка" },
  so: { name: "Сомали", region: "Африка" },
  sr: { name: "Суринам", region: "Америка" },
  ss: { name: "Южный Судан", region: "Африка" },
  st: { name: "Сан-Томе и Принсипи", region: "Африка" },
  sv: { name: "Сальвадор", region: "Америка" },
  sx: { name: "Синт-Мартен", region: "Америка" },
  sy: { name: "Сирия", region: "Азия" },
  sz: { name: "Эсватини", region: "Африка" },
  tc: { name: "Теркс и Кайкос", region: "Америка" },
  td: { name: "Чад", region: "Африка" },
  tf: { name: "Французские Южные территории", region: "Антарктика" },
  tg: { name: "Того", region: "Африка" },
  th: { name: "Таиланд", region: "Азия" },
  tj: { name: "Таджикистан", region: "Азия" },
  tk: { name: "Токелау", region: "Океания" },
  tl: { name: "Восточный Тимор", region: "Азия" },
  tm: { name: "Туркменистан", region: "Азия" },
  tn: { name: "Тунис", region: "Африка" },
  to: { name: "Тонга", region: "Океания" },
  tr: { name: "Турция", region: "Европа" },
  tt: { name: "Тринидад и Тобаго", region: "Америка" },
  tv: { name: "Тувалу", region: "Океания" },
  tw: { name: "Тайвань", region: "Азия" },
  tz: { name: "Танзания", region: "Африка" },
  ua: { name: "Украина", region: "Европа" },
  ug: { name: "Уганда", region: "Африка" },
  um: { name: "Внешние малые острова США", region: "Океания" },
  us: { name: "США", region: "Америка" },
  uy: { name: "Уругвай", region: "Америка" },
  uz: { name: "Узбекистан", region: "Азия" },
  va: { name: "Ватикан", region: "Европа" },
  vc: { name: "Сент-Винсент и Гренадины", region: "Америка" },
  ve: { name: "Венесуэла", region: "Америка" },
  vg: { name: "Британские Виргинские острова", region: "Америка" },
  vi: { name: "Виргинские острова США", region: "Америка" },
  vn: { name: "Вьетнам", region: "Азия" },
  vu: { name: "Вануату", region: "Океания" },
  wf: { name: "Уоллис и Футуна", region: "Океания" },
  ws: { name: "Самоа", region: "Океания" },
  xk: { name: "Косово", region: "Европа" },
  ye: { name: "Йемен", region: "Азия" },
  yt: { name: "Майотта", region: "Африка" },
  za: { name: "ЮАР", region: "Африка" },
  zm: { name: "Замбия", region: "Африка" },
  zw: { name: "Зимбабве", region: "Африка" },
  
  // Дополнительные региональные флаги
  eu: { name: "Европейский союз", region: "Организации" },
  un: { name: "ООН", region: "Организации" },
  arab: { name: "Лига арабских государств", region: "Организации" },
  asean: { name: "АСЕАН", region: "Организации" },
  
  // Региональные флаги
  "gb-eng": { name: "Англия", region: "Европа" },
  "gb-sct": { name: "Шотландия", region: "Европа" },
  "gb-wls": { name: "Уэльс", region: "Европа" },
  "gb-nir": { name: "Северная Ирландия", region: "Европа" },
  "es-ct": { name: "Каталония", region: "Европа" },
  "es-ga": { name: "Галисия", region: "Европа" },
  "es-pv": { name: "Страна Басков", region: "Европа" }
};

// Функция для получения информации о флаге
export const getFlagInfo = (code) => {
  return flagsConfig[code] || { name: "Неизвестная страна", region: "Не определен" };
};

// Функция для получения всех флагов, отсортированных по регионам
export const getAllFlags = () => {
  const flagsList = Object.entries(flagsConfig).map(([code, info]) => ({
    code,
    ...info
  }));

  // Группируем по регионам
  const groupedByRegion = flagsList.reduce((acc, flag) => {
    if (!acc[flag.region]) {
      acc[flag.region] = [];
    }
    acc[flag.region].push(flag);
    return acc;
  }, {});

  // Сортируем каждый регион по алфавиту
  Object.keys(groupedByRegion).forEach(region => {
    groupedByRegion[region].sort((a, b) => a.name.localeCompare(b.name, 'ru'));
  });

  return groupedByRegion;
};

// Функция для получения плоского списка флагов
export const getFlatFlagsList = () => {
  return Object.entries(flagsConfig).map(([code, info]) => ({
    code,
    ...info
  })).sort((a, b) => a.name.localeCompare(b.name, 'ru'));
};

// Популярные страны для показа вверху списка
export const popularCountries = [
  'my', // Малайзия
  'ru', // Россия
  'us', // США
  'gb', // Великобритания
  'de', // Германия
  'fr', // Франция
  'cn', // Китай
  'jp', // Япония
  'in', // Индия
  'br', // Бразилия
  'ca', // Канада
  'au', // Австралия
  'sg', // Сингапур
  'th', // Таиланд
  'id'  // Индонезия
];